module.exports = __webpack_public_path__ + "static/img/TQM.ee19872e.png";